export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "cancel-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "delete-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
      },
      "fr": {
        "cancel-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "delete-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer"])}
      }
    }
  })
}
